/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Admin_Credits_CountInputs */

const en_admin_credits_count = /** @type {(inputs: Admin_Credits_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} records`)
};

const zh_admin_credits_count = /** @type {(inputs: Admin_Credits_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`共 ${i?.count} 条`)
};

/**
* | output |
* | --- |
* | "{count} records" |
*
* @param {Admin_Credits_CountInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const admin_credits_count = /** @type {((inputs: Admin_Credits_CountInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Credits_CountInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_credits_count(inputs)
	return zh_admin_credits_count(inputs)
});
export { admin_credits_count as "admin.credits.count" }